<ng-container *ngIf="oferta">
  <div
    class="tag-promotion pull-right"
    (click)="onClick()"
    [ngClass]="{
      'remove-margin-top': removeMarginTop,
      'fixed-on-top': fixedOnTop
    }"
  >
      <div class="arrow-left">
          <div class="bullet"></div>
      </div>
      <a href="javascript:void(0);" routerLink="/produtos/ofertas/tags/{{oferta.tag}}" class="label-promotion first" (click)="onClick()">&nbsp;</a>
      <a href="javascript:void(0);" routerLink="/produtos/ofertas/tags/{{oferta.tag}}" class="label-promotion last" (click)="onClick()">{{oferta.nome}}</a>
  </div>
</ng-container>
